/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';

class Notice extends React.Component {
  render() {
    return <div>
      {this.props.children}
    </div>
  }
};
export default Notice;


// WEBPACK FOOTER //
// ./src/routes/notice/index.js